import styled from "styled-components";

export const CheckCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 22px;
  width: 22px;
  border-radius: 50px;
  border-style: solid;
  border-width: 2px;
  margin-right: 8px;
  border-color: ${(props) => props.theme.colors.primary} ;
`as any;

export const SubscriptionContainer= styled.div`
  display: flex;
  align-items: center;

  div {
    color: ${(props) => props.theme.colors.primary} ;
  }
`;

